import formatCurrencyPretty from './formatCurrencyPretty';
export default formatCurrencyPretty;